import { useEffect, useState } from "react";
import { fetchGallery, fetchProducts } from "../lib/api";
import { useReveal } from "../hooks/useReveal";

export default function Gallery() {
  const ref = useReveal();
  const [items, setItems] = useState([]);

  useEffect(() => {
    Promise.all([fetchGallery(), fetchProducts()])
      .then(([gallery, products]) => {
        const galleryUrls = (gallery || []).map((g) => ({ src: g.image_url, caption: g.caption }));
        const productUrls = (products || []).slice(0, 6).map((p) => ({ src: p.image_url, caption: p.name }));
        // Interleave gallery and product images for a varied masonry feel.
        const merged = [];
        const max = Math.max(galleryUrls.length, productUrls.length);
        for (let i = 0; i < max; i++) {
          if (galleryUrls[i]) merged.push(galleryUrls[i]);
          if (productUrls[i]) merged.push(productUrls[i]);
        }
        setItems(merged);
      })
      .catch(() => setItems([]));
  }, []);

  return (
    <div ref={ref} data-testid="gallery-page" className="pt-28 pb-24 bg-brand-ivory min-h-screen">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <header className="text-center mb-12 reveal">
          <span className="text-[11px] tracking-[0.32em] uppercase text-brand-gold font-semibold">Gallery</span>
          <h1 className="mt-3 font-serif-display text-4xl sm:text-5xl lg:text-6xl text-brand-brown leading-tight">
            A taste in pictures
          </h1>
          <p className="mt-4 text-brand-muted max-w-2xl mx-auto">
            Inside our roastery, on our shelves, and at the heart of every celebration — a closer look at Qamar Al Zahran.
          </p>
        </header>

        <div className="columns-1 sm:columns-2 lg:columns-3 gap-4 [&>*]:mb-4" data-testid="gallery-grid">
          {items.map((it, i) => (
            <div
              key={i}
              data-testid={`gallery-image-${i}`}
              className="reveal break-inside-avoid overflow-hidden rounded-2xl group shadow-md"
              style={{ transitionDelay: `${(i % 10) * 40}ms` }}
            >
              <img
                src={it.src}
                loading="lazy"
                alt={it.caption || `Gallery ${i + 1}`}
                className="zoom-img w-full object-cover"
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
